import React from 'react';
import Layout from "../../components/layout/Layout";
import AddProductForm from '../../components/products/AddProductForm'; // Ajusta la ruta según tu estructura
import styles from './AddProductPage.module.css';

const AddProductPage = () => {
    return (
        <Layout>
            <main className={styles.background}>
                <AddProductForm />
            </main>
        </Layout>
    );
};

export default AddProductPage;
